import { useMemo } from 'react'
import { toNumber } from 'lodash-es'
import { roofStoreyKey, useModelStore } from '@editorStores'

const useModelStoreys = () => {
  const availableStoreys = useModelStore(state => state.availableStoreys)

  const storeys = useMemo(
    () =>
      [...availableStoreys].sort((a, b) => {
        const aN = a === roofStoreyKey ? Number.MAX_SAFE_INTEGER : toNumber(a)
        const bN = b === roofStoreyKey ? Number.MAX_SAFE_INTEGER : toNumber(b)
        return toNumber(aN) - toNumber(bN)
      }),
    [availableStoreys],
  )

  return storeys
}

export default useModelStoreys
